import { render } from "./FakturaSpecs.vue?vue&type=template&id=01f42994&scoped=true"
import script from "./FakturaSpecs.vue?vue&type=script&lang=js"
export * from "./FakturaSpecs.vue?vue&type=script&lang=js"

import "./FakturaSpecs.vue?vue&type=style&index=0&id=01f42994&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f42994"]])

export default __exports__